import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { Is4upsBannerComponent } from './is4ups-banner.component';


@NgModule({
  declarations: [Is4upsBannerComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [Is4upsBannerComponent]
})
export class Is4upsBannerModule { }
